import { Button, List, Stack } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { NoResults } from "lib/@components/no-results/no-results"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { MacroListItem } from "./macro-list-item"

export function MacroList({ macros = [], selectedId, onSelect, onCreate }) {
    return (
        <If truthy={macros.length > 0}>
            <List disablePadding>
                <Repeat
                    list={macros}
                    pass="macro"
                    keyFn="id"
                    item={<MacroListItem selectedId={selectedId} onSelect={onSelect} />}
                />
            </List>
            <Else>
                <Stack sx={{ px: 2, py: 3 }} spacing={1.5} alignItems="center" data-cy="macro-list-empty">
                    <NoResults mt={0} width={220}>
                        No macros found.
                    </NoResults>
                    <If truthy={!!onCreate}>
                        <Button size="small" variant="outlined" onClick={handleCreate} data-cy="macro-empty-create">
                            Create macro
                        </Button>
                    </If>
                </Stack>
            </Else>
        </If>
    )

    function handleCreate() {
        if (!onCreate) return
        onCreate()
    }
}
